export default __webpack_public_path__ + "static/media/feature-a-2.81972207.jpg";